// CC-S2 (S2.1): lista de llamadas grabadas del CLIENTE (todas sus deudas +
// las marcadas sin deuda) con player inline. Espejo de LlamadasDeuda pero
// suscrito por clienteId. Reutiliza el service y el CSS de LlamadasDeuda.
//
// Las llamadas las puebla la Cloud Function procesarLlamada cuando la app
// KYE Call Center Desktop sube el WAV a Storage.

import { useEffect, useState } from "react";
import {
  escucharLlamadasPorCliente,
  getAudioPlayableUrl,
  formatDuracion,
} from "../../services/llamadasService";
import { toJsDate } from "../../helpers/fechas";
import "../DeudaDetalle/LlamadasDeuda.css";

function fmtFecha(ts) {
  const d = toJsDate(ts);
  if (!d) return "—";
  return d.toLocaleString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function LlamadasCliente({ clienteId }) {
  const [llamadas, setLlamadas] = useState(null);
  const [reproduciendo, setReproduciendo] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [errorUrl, setErrorUrl] = useState(null);
  const [cargandoUrl, setCargandoUrl] = useState(false);

  useEffect(() => {
    if (!clienteId) return undefined;
    const unsub = escucharLlamadasPorCliente(clienteId, setLlamadas, 100);
    return unsub;
  }, [clienteId]);

  async function handleReproducir(llamada) {
    setErrorUrl(null);
    setAudioUrl(null);
    setReproduciendo(llamada.id);
    setCargandoUrl(true);
    try {
      const url = await getAudioPlayableUrl(llamada.audioPath);
      setAudioUrl(url);
    } catch (err) {
      console.error("[LlamadasCliente] no se pudo cargar audio:", err);
      setErrorUrl(`No se pudo cargar el audio: ${err?.message || err}`);
    } finally {
      setCargandoUrl(false);
    }
  }

  if (llamadas === null) {
    return <p className="cliente-360-empty">Cargando llamadas…</p>;
  }

  if (llamadas.length === 0) {
    return (
      <p className="cliente-360-empty">
        Sin llamadas grabadas para este cliente.
      </p>
    );
  }

  return (
    <div className="llamadas-deuda">
      <ul className="llamadas-deuda-list">
        {llamadas.map((l) => {
          const isActive = reproduciendo === l.id;
          return (
            <li key={l.id} className={`llamadas-deuda-item ${isActive ? "active" : ""}`}>
              <div className="llamadas-deuda-row">
                <div className="llamadas-deuda-meta">
                  <strong>{fmtFecha(l.creadoEn || l.inicio)}</strong>
                  <span className="llamadas-deuda-sub">
                    {formatDuracion(l.duracionSeg)} ·{" "}
                    {l.responsableNombre || l.responsableEmail || "—"}
                    {l.telefonoMarcado ? ` · ${l.telefonoMarcado}` : ""}
                    {!l.deudaId ? " · sin deuda" : ""}
                  </span>
                </div>
                <button
                  type="button"
                  className="llamadas-deuda-btn"
                  onClick={() => handleReproducir(l)}
                  disabled={isActive && cargandoUrl}
                >
                  {isActive && cargandoUrl ? "Cargando…" : isActive ? "Reproduciendo" : "▶ Reproducir"}
                </button>
              </div>
              {isActive && audioUrl && (
                <audio
                  className="llamadas-deuda-audio"
                  controls
                  autoPlay
                  src={audioUrl}
                  onError={() => setErrorUrl("Error al reproducir el archivo.")}
                />
              )}
              {isActive && errorUrl && (
                <div className="llamadas-deuda-error">{errorUrl}</div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
